/**
 * Class to help facilitate and centralise caching data from an API
 */
class CacheHelper {
  constructor({ key, ttl }) {
    this.key = key;
    this.ttl = ttl;
  }

  /**
   * Get the data from a localStorage value
   * @param {String} key The key to check
   * @returns {*} The value, runs JSON.parse() to convert to JSON object
   */
  getItem(key) {
    return JSON.parse(localStorage.getItem(key || this.key));
  }

  setItem(key, data, timestamp = false) {
    localStorage.setItem(key, JSON.stringify(data));

    if (timestamp) {
      localStorage.setItem(`${key}_TTL`, new Date().getTime());
    }

    return true;
  }

  removeItem(key) {
    // remove any TTL keys that may exist too
    if (localStorage.getItem(`${key}_TTL`)) {
      localStorage.removeItem(`${key}_TTL`);
    }
    return localStorage.removeItem(key);
  }

  exists() {
    return localStorage.getItem(this.key);
  }

  /**
   * Check if we have a key, and that it is within the expiration period specified in config
   * I.e if someone creates a key at 10:50 with an expiration of 5 minutes, at 10.56 we need to remove it
   */
  existsAndIsValid(key = null) {
    const keyToCheck = key || this.key;
    // if there is no timestamp in the config
    if (!this.ttl) {
      console.error(`No expiration passed to cache helper for ${keyToCheck}`);
      return false; // this will prevent reading from cache but should get the cache sorted
    }
    if (localStorage.getItem(`${keyToCheck}_TTL`)) {
      const time = new Date().getTime();
      const ttl = parseInt(localStorage.getItem(`${keyToCheck}_TTL`));

      return time < ttl + this.ttl;
    }
  }
}

export default CacheHelper;
